<template>
  <section id="howToPlay" class="how-works-section">
    <b-container>
      <carousel :autoplay="false"
                :autoplayHoverPause="true"
                :items="1"
                :loop="false"
                :autoWidth="true"
                :nav="false"
                :dots="true"
                :margin="64"
                :responsive="{
                  0: { items: 1, margin: 0, autoWidth: false, loop: true, dots: false },
                  768: { items: 3, margin: 12, autoWidth: true, loop: false, dots: true },
                  1440: { items: 3, margin: 48, autoWidth: true, loop: false, dots: true }
                }">
      <div v-for="slide in slides" :key="slide.id" class="slider-content-container">
        <img v-if="$i18n.locale === 'en'" class="slider-img" :src="slide.imageUrlEng" :alt="'Slide ' + slide.id">
        <img v-else-if="$i18n.locale === 'uk'" class="slider-img" :src="slide.imageUrlUa" :alt="'Slide ' + slide.id">
        <img v-else class="slider-img" :src="slide.imageUrlEng" :alt="'Slide ' + slide.id">
        <div class="slider-content">
          <p class="content-text-slider">{{ $t(slide.text) }}</p>
        </div>
      </div>
    </carousel>
    </b-container>
  </section>
</template>
<script>
import Carousel from 'vue-owl-carousel'
export default {
  components: {
    Carousel // Додаємо компонент Carousel
  },
  data () {
    return {
      slides: [
        {
          id: 1,
          imageUrlEng: require('@/assets/img/slide/slide-1.png'),
          imageUrlUa: require('@/assets/img/slide/slide-1.png'),
          text: 'slider_content_1'
        },
        {
          id: 2,
          imageUrlEng: require('@/assets/img/slide/slide-2.png'),
          imageUrlUa: require('@/assets/img/slide/slide-2.png'),
          text: 'slider_content_2'
        },
        {
          id: 3,
          imageUrlEng: require('@/assets/img/slide/slide-3.png'),
          imageUrlUa: require('@/assets/img/slide/slide-3.png'),
          text: 'slider_content_3'
        },
        {
          id: 4,
          imageUrlEng: require('@/assets/img/slide/slide-4.png'),
          imageUrlUa: require('@/assets/img/slide/slide-4.png'),
          text: 'slider_content_4'
        },
        {
          id: 5,
          imageUrlEng: require('@/assets/img/slide/slide-5.png'),
          imageUrlUa: require('@/assets/img/slide/slide-5.png'),
          text: 'slider_content_4'
        },
        {
          id: 6,
          imageUrlEng: require('@/assets/img/slide/slide-6.png'),
          imageUrlUa: require('@/assets/img/slide/slide-6.png'),
          text: 'slider_content_4'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.how-works-section{
  padding-top: 120px;
  padding-bottom: 120px;
  @media screen and (min-width: 320px) {
  padding-top: 40px;
  padding-bottom: 40px;
  }
  @media screen and (min-width: 768px) {
  }
  @media screen and (min-width: 1440px) {
  padding-top: 120px;
  padding-bottom: 120px;
  }
  @media screen and (min-width: 1920px) {
  }
  .slider-content-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 40px;
    @media screen and (min-width: 320px) {
      flex-direction: column;
      gap: 24px;
    }
    @media screen and (min-width: 768px) {
      flex-direction: row;
      gap: 20px;
    }
    @media screen and (min-width: 992px) {
      flex-direction: row;
      gap: 40px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    .slider-img{
      max-width: 240px;
      width: 100%;
      height: auto;
      @media screen and (min-width: 320px) {
        max-width: 280px ;
      }
      @media screen and (min-width: 768px) {
        max-width: 280px;
      }
      @media screen and (min-width: 992px) {
      }
      @media screen and (min-width: 1440px) {
        max-width: 520px;
      }
      @media screen and (min-width: 1920px) {
        max-width: 774px;
      }
    }
    .slider-content{
      display: flex;
      max-width: 240px;
      width: 100%;
      padding: 40px 0px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      align-self: stretch;
      @media screen and (min-width: 320px) {
        max-width: unset ;
        padding: 0;
      }
      @media screen and (min-width: 768px) {
        max-width: 240px;
      }
      @media screen and (min-width: 992px) {
        max-width: 240px;
        padding: 40px 0px;
      }
      @media screen and (min-width: 1440px) {
        max-width: 280px;
      }
      @media screen and (min-width: 1920px) {
      }
      .content-text-slider{
        color: #000;
        font-family: $main-font;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 25.6px;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 22.4px;
        }
        @media screen and (min-width: 768px) {
          font-size: 14px;
          line-height: 22.4px;
        }
        @media screen and (min-width: 992px) {
        }
        @media screen and (min-width: 1440px) {
          font-size: 16px;
          line-height: 25.6px;
        }
      }
    }
  }
}
</style>
